__turbopack_context__.v({
  "body": "OtpStepUpModal-module__t6FU4G__body",
  "closeButton": "OtpStepUpModal-module__t6FU4G__closeButton",
  "codeInput": "OtpStepUpModal-module__t6FU4G__codeInput" + " " + "OtpStepUpModal-module__t6FU4G__input",
  "description": "OtpStepUpModal-module__t6FU4G__description",
  "error": "OtpStepUpModal-module__t6FU4G__error",
  "header": "OtpStepUpModal-module__t6FU4G__header",
  "input": "OtpStepUpModal-module__t6FU4G__input",
  "overlay": "OtpStepUpModal-module__t6FU4G__overlay",
  "paper": "OtpStepUpModal-module__t6FU4G__paper",
  "primaryButton": "OtpStepUpModal-module__t6FU4G__primaryButton",
  "resendButton": "OtpStepUpModal-module__t6FU4G__resendButton",
  "stepBadge": "OtpStepUpModal-module__t6FU4G__stepBadge",
  "target": "OtpStepUpModal-module__t6FU4G__target",
  "title": "OtpStepUpModal-module__t6FU4G__title",
});
